import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from "@angular/common/http";
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';

import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { AuthService } from 'app/auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private dialog: MatDialog,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    public authService: AuthService
  ) {
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error:HttpErrorResponse) => {
        console.log(error);
        // alert(error.error.message);
        let errorMessage = "Ocurrió un error desconocido";
        if(error.error.message){
          errorMessage = error.error.message;
        }

        let rspSi = 'MODALES.ACCIONES.aceptar';
        this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
        this.translateSrv.get('MODALES.ERRORES.'+errorMessage).subscribe((res: string) => {
          Swal.fire({
            title: res,
            icon: 'error',
            confirmButtonText: rspSi,
            confirmButtonColor: '#ff8f00',
            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
              if(errorMessage == "verifyToken_3"){
                this.cerrarSesion();
              }
            }
          });
        });
        return throwError(error);

      })
    );
  }

  cerrarSesion() {
    this.authService.logout();
    setInterval(() => window.location.reload(), 1500);
  }

}
